// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".orBar[data-v-f7b5e496]{display:flex;justify-content:space-between;align-items:center;margin:24px 0}.orBar .line[data-v-f7b5e496]{width:100%;height:1px;background-color:var(--color-light-grey)}.orBar .text[data-v-f7b5e496]{color:var(--color-dark-grey);font-weight:600;margin:0 24px}", ""]);
// Exports
module.exports = exports;
